import { ref } from 'vue'
import { defineStore } from "pinia";
import { pipedriveApi } from '@/services/pipedriveApi';

export const pipedriveStore = defineStore("pipedrive", () => {
  const loadingStatus = ref(false);

  const getOrderSummary = async (orderId) => {
    return await pipedriveApi.getRealEstateOrderSummary(orderId, (res) => res.data, () => {});
  }

  async function loadRealEstateOrderSummary(orderId) {
    try {
      loadingStatus.value = true;
      return await getOrderSummary(orderId);
    } catch (error) {
      throw error
    } finally {
      loadingStatus.value = false;
    }
  }

  return {
    loadRealEstateOrderSummary,
    loadingStatus,
  };
});
